var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_wrapper"},[_c('Sidebar'),_c('Earth'),_c('PosTip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }